export default "/header_logo.ef0e026a-75fa74.svg?svgr";